//Executed after SWYM has loaded all necessary resources.
function onSwymLoadCallback(swat) {
  // Please make all SWYM-related API calls inside this function.
  // You can use the swat argument within this scope.

  // Define success callback
  let onSuccess = function(lists) {

    // If lists array is empty
    if (lists.length == 0) {
      // Define the list config
      let listConfig = {
        "lname": "wishlist", // unique list name.
      };

      // Define success callback
      let onSuccess = function(newList) {
        // Executed when a new list is successfully created

        window.apps = {
          wishlist: {
            listId: newList.lid,
            list: newList
          }
        }

       publish('wishlist-loaded', newList)
      }

      // Define error callback
      let onError = function(error) {
        // Error is an xhrObject
        console.error("Error while creating a List", error);
      }

      // Create a new list with the above callbacks and config
      swat.createList(listConfig, onSuccess, onError);
    } else {
      window.apps = {
        wishlist: {
          listId: lists[0].lid,
          list: lists[0]
        }
      }

      publish('wishlist-loaded', lists[0])
    }
  }

  // Define error callback
  let onError = function(error) {
    // Error is an xhrObject
    console.error("Error while fetching all Lists", error);
  }

  // Call `fetchLists` function
  swat.fetchLists({
    callbackFn: onSuccess,
    errorFn: onError
  });
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(onSwymLoadCallback);

if (window._swat) {
  console.info("Swym scripts tags are installed on your store");
} else {
  console.error("Swym scripts tags aren`t installed on your store");
}